import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import {adminServices} from "../services/AdminServices";
import InputText1 from './InputText1';
import Button from './Button';
import LoadingModal from "./LoadingModal";
import { jwtDecode } from "jwt-decode";
import { validatePassword } from "../tools/passwordPolicy";
const customStyles = { 
    overlay: { 
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
    }, 
    content: {
        width: '520px', margin: 'auto', maxHeight: '80vh', overflow: 'auto'
      
    },
 };

const PasswordResetForm = ({show,onClose})=>{
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300);
    const [failedAttempts, setFailedAttempts] = useState(2);
    const [verified, setVerified] = useState(false);

    const [otp, setOtp] = useState("");

    const [changeVia, setChangeVia] = useState("oldpassword");

    var token = localStorage.getItem("appToken");
    let userId = jwtDecode(token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];

    useEffect(() => {
    // Timer countdown for 5 minutes
    if (isResendDisabled) {
        const interval = setInterval(() => {
        setTimeLeft(prev => {
            if (prev <= 1) {
            clearInterval(interval);
            setIsResendDisabled(false); // Enable button after 5 minutes
            return 0;
            }
            return prev - 1;
        });
        }, 1000);

        return () => clearInterval(interval);
    }
    }, [isResendDisabled]);

    const validateForm = () => {
        setErrors([]);
        if(changeVia == "oldpassword"){
            if(oldPassword == "" || newPassword == "" || confirmPassword == ""){
                setErrors(["Please fill all fields"]);
                setValidated(true);
                return false;
            }
        }
        else{
            if(newPassword == "" || confirmPassword == ""){
                setErrors(["Please fill all fields"]);
                setValidated(true);
                return false;
            }
        }

        if(newPassword != confirmPassword){
            setErrors(["New Password and Confirm Password do not match. Please try again."]);
            setValidated(true);
            return false;
        }

        const policyCheck = validatePassword(newPassword);
        if (!policyCheck.valid) {
            setErrors(policyCheck.errors);
            setValidated(true);
            return false;
        }

        return true;
    }

    const resendOtp = async () => {
        setLoading("Resending OTP...");
        const secretKey = localStorage.getItem("secretKey");
        const emailAddr = localStorage.getItem("emailAddr");

        if (!secretKey || !emailAddr) {
            console.error("Missing required fields in localStorage.");
            return;
        }

        await adminServices.postData('regenerate-otp?emailAddress=' + emailAddr + "&secretKey=" + secretKey, {})
            .then(response => {
            if (response.status === 200) {
                //console.log("OTP Resent Successfully!");
                setLoading("");
                setIsResendDisabled(true); // Disable button for 5 minutes
                setTimeLeft(300); // Reset timer
            }
            })
            .catch(error => {
            console.error("Failed to resend OTP:", error);
            });
    };

    const handleSubmit = async () => {
        if(validateForm()){
            setLoading(true);
            let formData = new FormData();
            formData.append("UserId", userId);
            formData.append("OldPassword", oldPassword);
            formData.append("NewPassword", newPassword);

            await adminServices.passwordReset(formData).then((response) => {
                if(response.status === 200){
                    setLoading(false);
                    window.alert("Password reset successful");
                    window.location.reload();
                }
            }).catch(error => {

                if(error.status == 401){
                    window.location.href = "/";
                }

                if(error.status == 409){
                    setLoading(false);
                    window.alert("Old Password is incorrect. Please try again.");
                }

                if(error.status == 404){
                    setLoading(false);
                    window.alert("User data does not exist. Please try again.");
                }

                if(error.status == 500){
                    setLoading(false);
                    window.alert("Internal Server Error. Please try again.");
                }

            })
            
        }
        else{
            setValidated(true);
        }
    }

    const handleSubmit2 = async () => {
        if(validateForm()){
            setLoading(true);
            let formData = new FormData();
            formData.append("UserId", userId);
             formData.append("OldPassword", '-');
            formData.append("NewPassword", newPassword);

            await adminServices.passwordReset(formData,"via-otp").then((response) => {
                if(response.status === 200){
                    setLoading(false);
                    window.alert("Password reset successful");
                    window.location.reload();
                }
            }).catch(error => {

                if(error.status == 401){
                    window.location.href = "/";
                }

                if(error.status == 409){
                    setLoading(false);
                    window.alert("Old Password is incorrect. Please try again.");
                }

                if(error.status == 404){
                    setLoading(false);
                    window.alert("User data does not exist. Please try again.");
                }

                if(error.status == 500){
                    setLoading(false);
                    window.alert("Internal Server Error. Please try again.");
                }

            })
            
        }
        else{
            setValidated(true);
        }
    }

    return (
        <Modal
            
            isOpen={show}
            shouldCloseOnEsc={false} 
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            onRequestClose={onClose}
        >
        <LoadingModal show={loading} message={"Saving data..."} />
        <div className="password-reset-modal-content">
         <div style={{display:"flex",justifyContent:'space-between',zIndex:999}} className="mb-3">
                <h3>Reset Password</h3>
                <button style={{backgroundColor:'#fff',
                    borderColor:'#d2d2d2',
                    color:'#555',
                    borderRadius:100,
                    fontSize:20,
                    fontWeight: 'bolder',
                    fontFamily: 'monospace',
                    borderWidth:0}}
                    onClick={onClose}
                    >
                        x
                    </button>
            </div>
                {/* Password policy banner */}
                <div className="password-policy-banner" style={{background:'#f1f9ff',border:'1px solid #dbeffd',padding:12,borderRadius:6,marginBottom:12}}>
                    <strong>Password Requirements:</strong>
                    <ul style={{marginTop:8,marginBottom:0,paddingLeft:18}}>
                        <li>Minimum 8 characters</li>
                        <li>At least 1 uppercase letter (A-Z)</li>
                        <li>At least 1 lowercase letter (a-z)</li>
                        <li>At least 1 number (0-9)</li>
                        <li>At least 1 special character (e.g. !@#$%^&*)</li>
                    </ul>
                </div>
                    
            {changeVia == "oldpassword" && <div className="flexRow">
                <InputText1 type="password" title={"Old Password"} value={oldPassword} onChange={(e)=>{ setOldPassword(e.target.value) }} />
            </div>}

            {changeVia == "otp" && !verified && <div className="flexRow">
                <InputText1 type="password" maxLength={6} title={"One Time PIN"} value={otp} onChange={(e)=>{ setOtp(e.target.value) }} />
                <div style={{marginTop: '22px'}}>
                    <Button type="button" variant={"primary"} size={'md'} onClick={ async (e)=>{
                        e.preventDefault();
                        setLoading(true);
                        await adminServices.verify(otp).then((r)=>{
                            if(r.status == 200){
                                setVerified(true);
                                setLoading(false);
                            }
                        }).catch((e)=>{
                            if(e.status == 409){
                                setFailedAttempts(prev => prev - 1);
                                if(failedAttempts === 0){
                                    //setErrorLogin("Maximum number of attempts reached. will be redirected to login page automatically");
                                    window.alert("Maximum number of attempts reached");
                                    setLoading(false);
                                    setChangeVia("oldpassword");
                                    setIsResendDisabled(false);
                                    setTimeLeft(300);
                                    setFailedAttempts(2);
                                    setVerified(false);
                                    onClose();
                                    return;
                                }
                                
                                window.alert("Incorrect OTP. Please try again.");
                                setLoading(false);
                                return;
                            }
                        })
                    } } disabled={loading}>Verify</Button>
                </div>
            </div>}

            {(changeVia == "oldpassword" ||(changeVia == "otp" && verified)) &&<div className="flexRow">
                <InputText1 type="password" title={"New Password"} value={newPassword} onChange={(e)=>{ setNewPassword(e.target.value) }} />
            </div>}

            {(changeVia == "oldpassword" ||(changeVia == "otp" && verified)) && <div className="flexRow">
                <InputText1 type="password" title={"Confirm Password"} value={confirmPassword} onChange={(e)=>{ setConfirmPassword(e.target.value) }} />
            </div>}

            {errors && errors.length > 0 && (
                            <div className="password-error-summary" style={{color:'#8b0000',background:'#fff5f5',border:'1px solid #f5c6cb',padding:10,borderRadius:6,marginBottom:10}}>
                                <strong>Fix the following:</strong>
                                <ul style={{marginTop:6,marginBottom:0,paddingLeft:18}}>
                                    {errors.map((err,idx)=> <li key={idx}>{err}</li>)}
                                </ul>
                            </div>
                        )}

            <div style={{display:'flex',justifyContent:'flex-end',alignItems:'center',gap:12}}>
                {!verified && <Button type="button" variant={"primary"} size={'md'} onClick={ async (e)=>{
                    e.preventDefault();
                    setChangeVia("otp");
                    setIsResendDisabled(true) ;
                    await resendOtp();
                }} disabled={isResendDisabled}>
                    {isResendDisabled ? "Resend OTP in " + timeLeft + " seconds" : "Via OTP"}
                </Button>}

                {changeVia == "oldpassword" && <Button variant={"success"} size={'md'} onClick={handleSubmit}>
                    Submit
                </Button>}
                {changeVia == "otp" && <Button variant={"success"} size={'md'} onClick={handleSubmit2} disabled={!verified}>
                    Submit
                </Button>}

                <Button variant={"secondary"} size={'md'} onClick={()=>{
                    setChangeVia("oldpassword");
                    setIsResendDisabled(false);
                    setTimeLeft(300);
                    setFailedAttempts(2);
                    setVerified(false);
                    onClose();
                }}>
                    Cancel
                </Button>
            </div>
        </div>
        </Modal>
    )
}

export default PasswordResetForm;